import "../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { HyperApp } from "./HyperApp.es.js";
import { PortalSlot, setupPortalSlot } from "./PortalSlot.es.js";
import Quasar from "../node_modules/.pnpm/quasar@2.17.4/node_modules/quasar/src/vue-plugin.es.js";
/* empty css               */
import themingPlugin, { useTheming } from "./plugins/theming/theming.es.js";
import install from "../node_modules/.pnpm/i18next-vue@4.0.0_i18next@23.16.8_vue@3.5.13_typescript@4.9.5_/node_modules/i18next-vue/dist/index.es.js";
import { setupLoader, loadIcon } from "@odin/assets";
import { setupMessages } from "@odin/services";
import { WsAnalyticsDirective } from "./directives/wsAnalytics.directive.es.js";
import { WsAutofocusDirective } from "./directives/wsAutofocus.directive.es.js";
import { set } from "lodash-es";
import { version } from "@odin/services/package.json";
import { createApp } from "../node_modules/.pnpm/@vue_runtime-dom@3.5.13/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.es.js";
import { h } from "../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
const app = createApp(() => h(HyperApp));
const setupComponents = async (config) => {
  if (version !== config.servicesVersion) {
    throw new Error(`Services package version mismatch.
          Expected: ${version}, got: ${config.servicesVersion}`);
  }
  prepareUikitWrapper(config);
  setupPortalSlot(window._WS_COMPONENTS_PACKAGE_TARGET);
  app.component("PortalSlot", PortalSlot);
  app.directive("ws-analytics", WsAnalyticsDirective);
  app.directive("ws-autofocus", WsAutofocusDirective);
  setupMessages({ translate: config.i18next.t, log: console.error });
  setupTheming();
  setupTranslationPlugin(config);
  app.use(Quasar, { config: { lang: { noHtmlAttrs: true } } });
  app.mount(config.mountTarget || "#uikit-app");
  setupQuasarIconSet();
};
const iconSet = Quasar.iconSet;
const setCustomIcon = async (iconName, path) => {
  var _a;
  const icon = await loadIcon(iconName);
  const svg = decodeURIComponent(icon.replace("data:image/svg+xml,", ""));
  const quasarFormat = (_a = svg.match(/d=['"](.*?)['"]/)) == null ? void 0 : _a[1];
  set(iconSet, path, quasarFormat);
};
async function setupQuasarIconSet() {
  await setCustomIcon("arrow_down", "arrow.down");
  await setCustomIcon("close", "field.clear");
  Quasar.iconSet.set(iconSet);
}
function prepareUikitWrapper(config) {
  if (!config.mountTarget) {
    const uikitEl = document.createElement("div");
    uikitEl.setAttribute("id", "uikit-app");
    document.querySelector("body").appendChild(uikitEl);
  }
}
app.use(themingPlugin);
function setupTranslationPlugin(config) {
  document.documentElement.lang = config.i18next.language;
  if (config.i18next) {
    app.use(install, {
      i18next: config.i18next,
      rerenderOn: ["languageChanged", "loaded", "added"]
    });
  }
}
function setupTheming() {
  const { theme } = useTheming();
  setupLoader(() => theme.value);
}
export {
  app,
  setupComponents
};
//# sourceMappingURL=main.es.js.map
